<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div role="tablist">
                    <div class="card">
                        <div :class="`card-header ${building.isNotExist ? 'bg-gray' : (building.isNotEvaluated ? 'bg-red' : 'bg-light')}`">
                            <div class="row">
                                <div class="col-12 col-md-6" v-b-toggle="'collapse'+index" style="cursor: pointer"
                                     v-tooltip="'Остки маълумотларни очиш'">
                                    <span><i class="fa fa-arrow-down"></i><b :class="{red: $v.$invalid}">№{{index + 1}}.(#id:{{building.id}}) {{building.name}}</b></span>
                                    <div>{{building.cadastreNumber}}</div>
                                    <span v-if="building.isNotExist" class="text-danger"> {{$t('building.field.notExist').toLowerCase()}}</span>
                                    <span v-if="building.isNotEvaluated" class="text-danger"> {{$t('building.field.notEvaluated').toLowerCase()}}</span>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="pull-right d-flex align-items-center">
                                        <span class="font-weight-bold mr-5">{{calculatedAll.calculated.price.expense | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span>
                                        <button class="all-btn add-btn" @click="save" :disabled="processing"
                                                v-if="canSave">
                                            {{$t("action.save")}}
                                        </button>
                                        <button class="all-btn ml-3" @click="showCalculatedTable(buildingId)" v-if="hasEvaluation">
                                            Жадвал
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <hr/>
                                </div>
                            </div>
                            <div class="row live__scroll flex">
                                <div class="col-8 col-lg-3 col-md-4">
                                    <div class="form-group">
                                        <label>{{$t("building.field.buildingType")}} <span class="red">*</span></label>
                                        <div class="cadastre-building-wrapper"
                                             @click="showCadastreBuildingSelect(buildingId)">
                                            <p class="cadastre-building-input" v-if="building.cadastreBuilding">
                                                {{building.cadastreBuilding.name}}</p>
                                            <p class="cadastre-building-input2"
                                               :class="{'valid': $v.building.cadastreBuilding.$error}" v-else>Бино
                                                турини танлаш учун бу ерга босинг!</p>
                                        </div>
                                        <!--<v-select v-model="building.cadastreBuilding" label="name"-->
                                        <!--:options="cadastreBuildings"-->
                                        <!--:filterable="false"-->
                                        <!--@search="onCadastreBuildingSearch"-->
                                        <!--@search:focus="onCadastreBuildingFocus"-->
                                        <!--:class="{invalid : $v.building.cadastreBuilding.$error}">-->
                                        <!--<template slot="option" slot-scope="option" v-if="option && option.name">-->
                                        <!--<div v-html="option.name" style="font-weight: bold"></div>-->
                                        <!--<template v-if="option.data">-->
                                        <!--<template v-if="!option.data.capitalGroupByCategory && option.data.capitalGroup && option.data.capitalGroup.length > 0">-->
                                        <!--<div>Капиталлик гуруҳи: {{option.data.capitalGroup}}</div>-->
                                        <!--</template>-->
                                        <!--<template v-if="option.data.category && option.data.category.settings">-->
                                        <!--<template v-for="category in Object.keys(option.data.category.settings)">-->
                                        <!--<template v-if="option.data.category.settings[category].criteria && option.data.category.settings[category].criteria.length > 0">-->
                                        <!--<div :key="category">-->
                                        <!--Категория: {{category}}. {{criteriaAsText(option.data.category.settings[category])}}-->
                                        <!--</div>-->
                                        <!--</template>-->
                                        <!--</template>-->
                                        <!--</template>-->
                                        <!--</template>-->
                                        <!--<template v-if="option.tableInfo && option.tableInfo.length > 0">-->
                                        <!--<div>Жадвал: {{option.tableInfo}}</div>-->
                                        <!--</template>-->
                                        <!--</template>-->
                                        <!--<template slot="selected-option" v-if="building && building.cadastreBuildings && building.cadastreBuildings.name">-->
                                        <!--<div v-html="building.cadastreBuildings.name"></div>-->
                                        <!--</template>-->
                                        <!--<span slot="no-options">{{$t("messages.combo.empty")}}</span>-->
                                        <!--</v-select>-->
                                        <!--<div class="red" v-if="$v.building.cadastreBuilding.$error">{{$t("building.validation.buildingType")}}</div>-->
                                    </div>
                                </div>
                                <div class="col-8 col-lg-3 col-md-4">
                                    <div class="form-group">
                                        <label>{{$t("building.field.buildingTypeCategory")}} <span class="red">*</span></label>
                                        <select class="form-control" v-if="isCategorySelectableAndHasCategories"
                                                v-model="building.cadastreBuildingCategory">
                                            <option value=""></option>
                                            <option :value="option"
                                                    v-for="option in building.cadastreBuilding.data.category.codes"
                                                    :key="option">{{option}}
                                            </option>
                                        </select>
                                        <input class="form-control" v-else :value="calculatedAll.category.code"
                                               readonly>
                                    </div>
                                </div>
                                <template v-for="(field, index) in cadastreBuildingFields">
                                    <div class="col-8 col-lg-3 col-md-4" :key="`cadastre-building-fields-${field.code}`" v-if="isLeftCustomField(field)">
                                        <div class="form-group">
                                            <label>{{field.name}} <span class="red"
                                                                        v-if="field.required">*</span></label>
                                            <template v-if="field.type === 'TEXT'">
                                                <input type="text" class="form-control" v-model="field.value"
                                                       :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                                       @change="onFieldValueChange(field)"/>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customField",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                            <template v-else-if="field.type === 'INTEGER'">
                                                <numeric-input v-model="field.value"
                                                               :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                                               @change="onFieldValueChange(field)"></numeric-input>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customField",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                            <template v-else-if="field.type === 'DECIMAL'">
                                                <numeric-input v-model="field.value" :precision="3"
                                                               :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                                               @change="onFieldValueChange(field)"></numeric-input>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customField",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                            <template v-else-if="field.type === 'LISTBOX'">
                                                <select class="form-control" v-model="field.value"
                                                        :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                                        @change="onFieldValueChange(field)">
                                                    <option :value="option.id"
                                                            v-for="option in cadastreBuildingFieldReferences[field.reference.code]"
                                                            :key="`cadastre-building-fields-listbox-${option.id}`">{{option.name}}
                                                    </option>
                                                </select>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customFieldSelect",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                            <template v-else-if="field.type === 'COMBOBOX'">
                                                <v-select v-model="field.selected" label="name"
                                                          :options="cadastreBuildingFieldReferences[field.reference.code]"
                                                          :filterable="false"
                                                          :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                                          @change="onFieldValueChange(field)">
                                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                </v-select>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customFieldSelect",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                            <template v-else-if="field.type === 'MULTISELECT'">
                                                <treeselect class="form-control" v-model="field.selected"
                                                            :multiple="true"
                                                            placeholder="Танланг..."
                                                            :options="multiSelectOptions(cadastreBuildingFieldReferences[field.reference.code])"
                                                            :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                                            @input="onFieldValueChange(field)"
                                                            :disabled="isFieldDisabled"
                                                ></treeselect>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customFieldSelect",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                            <template v-else-if="field.type === 'DATE_PICKER'">
                                                <datepicker class="form-control" format="dd/MM/yyyy"
                                                            v-model="field.date" :clear-button="true"
                                                            :class="{invalid : $v.cadastreBuildingFields.$each[index].date.$error}"
                                                            @change="onFieldValueChange(field)"></datepicker>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customFieldSelect",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                                <template v-for="(field, index) in cadastreBuildingFields">
                                    <div class="col-8 col-lg-3 col-md-4" :key="`cadastre-building-fields2-${field.code}`" v-if="isRightCustomField(field)">
                                        <div class="form-group">
                                            <label>{{field.name}} <span class="red"
                                                                        v-if="field.required">*</span></label>
                                            <template v-if="field.type === 'TEXT'">
                                                <input type="text" class="form-control" v-model="field.value"
                                                       :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                                       @change="onFieldValueChange(field)"/>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customField",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                            <template v-else-if="field.type === 'INTEGER'">
                                                <numeric-input v-model="field.value"
                                                               :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                                               @change="onFieldValueChange(field)"></numeric-input>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customField",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                            <template v-else-if="field.type === 'DECIMAL'">
                                                <numeric-input v-model="field.value" :precision="3"
                                                               :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                                               @change="onFieldValueChange(field)"></numeric-input>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customField",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                            <template v-else-if="field.type === 'LISTBOX'">
                                                <select class="form-control" v-model="field.value"
                                                        :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                                        @change="onFieldValueChange(field)">
                                                    <option :value="option.id"
                                                            v-for="option in cadastreBuildingFieldReferences[field.reference.code]"
                                                            :key="`cadastre-building-fields2-listbox-${option.id}`">{{option.name}}
                                                    </option>
                                                </select>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customFieldSelect",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                            <template v-else-if="field.type === 'COMBOBOX'">
                                                <v-select v-model="field.selected" label="name"
                                                          :options="cadastreBuildingFieldReferences[field.reference.code]"
                                                          :filterable="false"
                                                          :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                                          @change="onFieldValueChange(field)">
                                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                </v-select>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customFieldSelect",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                            <template v-else-if="field.type === 'MULTISELECT'">
                                                <treeselect class="form-control" v-model="field.selected"
                                                            :multiple="true"
                                                            placeholder="Танланг..."
                                                            :options="multiSelectOptions(cadastreBuildingFieldReferences[field.reference.code])"
                                                            :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                                            @input="onFieldValueChange(field)"
                                                            :disabled="isFieldDisabled"
                                                ></treeselect>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customFieldSelect",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                            <template v-else-if="field.type === 'DATE_PICKER'">
                                                <datepicker class="form-control" format="dd/MM/yyyy"
                                                            v-model="field.date" :clear-button="true"
                                                            :class="{invalid : $v.cadastreBuildingFields.$each[index].date.$error}"
                                                            @change="onFieldValueChange(field)"></datepicker>
                                                <div class="red"
                                                     v-if="$v.cadastreBuildingFields.$each[index].value.$error">
                                                    {{$t("building.validation.customFieldSelect",
                                                    [field.name.toLowerCase()])}}
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                                <!-- <template v-if="isValidIncome">
                                      <div class="col-8 col-lg-2 col-md-4">
                                          <div class="form-group">
                                              <label>Ижарага бериш майдони кв.м<span class="red">*</span></label>
                                              <numeric-input
                                                      v-model="comparison.rentArea"
                                                      :precision="6" align="right"
                                                      :class="{invalid: $v.comparison.rentArea.$error}"
                                              ></numeric-input>
                                          </div>
                                      </div>
                                      <template v-if="!isOwnerTypePhysical">
                                          <div class="col-12 col-md-3">
                                              <div class="form-group">
                                                  <label>Фойдаланиш фаолият номи<span class="red">*</span></label>
                                                  <div :class="{invalid: $v.comparison.purposeRentingId.$error}">
                                                      <treeselect class="form-control"
                                                                  :multiple="false"
                                                                  :disable-branch-nodes="true"
                                                                  placeholder="Танланг..."
                                                                  v-model="comparison.purposeRentingId"
                                                                  :options="purposeRentingAreas"
                                                      >
                                                      </treeselect>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="col-12 col-md-3">
                                              <div class="form-group">
                                                  <label>Қурилиш тури бўйича коэффициент(Кк)<span
                                                          class="red">*</span></label>
                                                  <div :class="{invalid: $v.comparison.coefficientOfConstruction.$error}">
                                                      <v-select label="name"
                                                                :filterable="false"
                                                                :options="incomeKkCoefficients"
                                                                v-model="comparison.coefficientOfConstruction"
                                                                @search:focus="onRentingCoefficientFocus"
                                                      >
                                                          <template slot="option" slot-scope="option" v-if="option">
                                                              <div v-html="option.name"></div>
                                                          </template>
                                                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                      </v-select>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="col-12 col-md-3">
                                              <div class="form-group">
                                                  <label>Ҳудуддан фойдаланиш коэффициент(Кҳ)<span
                                                          class="red">*</span></label>
                                                  <div :class="{invalid: $v.comparison.coefficientOfConnectedArea.$error}">
                                                      <v-select label="name"
                                                                :filterable="false"
                                                                :options="incomeKxCoefficients"
                                                                v-model="comparison.coefficientOfConnectedArea"
                                                                @search:focus="onRentingCoefficientFocus"
                                                      >
                                                          <template slot="option" slot-scope="option" v-if="option">
                                                              <div v-html="option.name"></div>
                                                          </template>
                                                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                      </v-select>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="col-12 col-md-3">
                                              <div class="form-group">
                                                  <label>Фойдаланишда қулайлик коэффициент(Кт)<span
                                                          class="red">*</span></label>
                                                  <div :class="{invalid: $v.comparison.coefficientOfCommercialGoal.$error}">
                                                      <v-select label="name"
                                                                :filterable="false"
                                                                v-model="comparison.coefficientOfCommercialGoal"
                                                                :options="incomeKtCoefficients"
                                                                @search:focus="onRentingCoefficientFocus"
                                                      >
                                                          <template slot="option" slot-scope="option" v-if="option">
                                                              <div v-html="option.name"></div>
                                                          </template>
                                                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                      </v-select>
                                                  </div>
                                              </div>
                                          </div>
                                      </template>
                                  </template> -->
                            </div>
                        </div>
                        <b-collapse :id="'collapse'+index" accordion="my-accordion" role="tabpanel"
                                    v-model="isAddValueCollapse">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-8 col-md-6">
                                        <div class="form-group" v-if="hasField('floors')">
                                            <label>{{$t("building.field.floors")}} <span class="red">*</span></label>
                                            <numeric-input v-model="building.floors"
                                                           :class="{invalid : $v.building.floors.$error}"></numeric-input>
                                            <div class="red" v-if="$v.building.floors.$error">
                                                {{$t("building.validation.floors")}}
                                            </div>
                                        </div>
                                        <div class="form-check pl-0 checkbox-inline" v-if="hasPermission('NEW_REAL_ESTATE_BUILDING_MANUAL_VOLUME')">
                                            <label class="form-check-label"
                                                   style="padding-left:22px !important">
                                                <input class="form-check-input" type="checkbox"
                                                       v-model="building.hasManualVolume"
                                                >
                                                <span class="form-check-sign"></span>
                                                Хажм кулда хисоблаш
                                            </label>
                                        </div>
                                        <div class="form-group" v-if="hasField('volume')">
                                            <label>{{$t("building.field.volume")}} <span class="red">*</span></label>
                                            <numeric-input v-model="building.volume" :precision="2"></numeric-input>
                                            <div class="red" v-if="$v.building.volume.$error">
                                                {{$t("building.validation.volume")}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label>{{$t("building.field.name")}} <span class="red">*</span></label>
                                            <input type="text" class="form-control" v-model="building.name"
                                                   :class="{invalid : $v.building.name.$error}"/>
                                            <div class="red" v-if="$v.building.name.$error">
                                                {{$t("building.validation.name")}}
                                            </div>
                                        </div>
                                        <div class="form-group" v-if="hasField('madeYear')">
                                            <label>{{$t("building.field.madeYear")}} <span class="red">*</span></label>
                                            <numeric-input v-model="building.madeYear"
                                                           :max="maxMadeYear"></numeric-input>
                                        </div>
                                        <div class="form-group" v-if="hasField('area')">
                                            <label>{{$t("building.field.area")}} <span class="red">*</span></label>
                                            <numeric-input v-model="building.area" @input="calculateVolume"
                                                           :precision="2"
                                                           @change="onBuildingAreaChange"
                                                           :class="{invalid : $v.building.area.$error}"></numeric-input>
                                            <div class="red" v-if="$v.building.area.$error">
                                                {{$t("building.validation.area")}}1
                                            </div>
                                        </div>
                                      <div class="form-group" v-if="building.usefulArea">
                                        <label>{{$t("building.field.usefulArea")}} <span class="red">*</span></label>
                                        <numeric-input v-model="building.usefulArea" @input="calculateVolume"
                                                       :precision="2"
                                                       @change="onBuildingAreaChange"></numeric-input>
                                      </div>
                                        <div class="form-group" v-if="hasField('height')">
                                            <label>{{$t("building.field.height")}} <span class="red">*</span></label>
                                            <numeric-input v-model="building.height" @input="calculateVolume"
                                                           :precision="2"
                                                           :class="{invalid : $v.building.height.$error}"></numeric-input>
                                            <div class="red" v-if="$v.building.height.$error">
                                                {{$t("building.validation.height")}}
                                            </div>
                                        </div>
                                        <div class="form-group" v-if="hasField('height_inner')">
                                            <label>{{$t("building.field.heightInner")}} <span
                                                    class="red">*</span></label>
                                            <numeric-input v-model="building.heightInner"
                                                           :precision="2"></numeric-input>
                                        </div>
                                    </div>
                                    <div class="col-8 col-md-6">
                                        <div class="form-group" v-if="hasField('earthquake_point')">
                                            <label>{{$t("building.field.earthquakePoint")}} <span
                                                    class="red">*</span></label>
                                            <select class="form-control" v-model="building.earthquakePoint"
                                                    :class="{invalid : $v.building.earthquakePoint.$error}">
                                                <option :value="option.points"
                                                        v-for="option in filteredEarthquakePoints" :key="`earthquake-point-${option.points}`">
                                                    {{option.points}}
                                                </option>
                                            </select>
                                            <div class="red" v-if="$v.building.earthquakePoint.$error">
                                                {{$t("building.validation.earthquakePoint")}}
                                            </div>
                                        </div>
                                        <div class="form-group" v-if="hasField('business_coefficient')">
                                            <label>{{$t("building.field.businessCoefficient")}} <span
                                                    class="red">*</span></label>
                                            <select class="form-control" v-model="building.businessCoefficient"
                                                    :class="{invalid : $v.building.businessCoefficient.$error}">
                                                <option :value="option.value" v-for="(option, index) in coefficient.business"
                                                        :key="`business-coefficient-${index}-${option.value}`">{{option.value}} ({{option.period}}) Co {{option.valueCo}}
                                                </option>
                                            </select>
                                            <div class="red" v-if="$v.building.businessCoefficient.$error">
                                                {{$t("building.validation.businessCoefficient")}}
                                            </div>
                                        </div>
                                        <div class="form-group" v-if="building.cadastreBuilding && building.cadastreBuilding.data
                                && building.cadastreBuilding.data.additionalValues && building.cadastreBuilding.data.additionalValues.length > 0">
                                            <label>{{$t("building.field.additionalValues")}}</label>
                                            <treeselect class="form-control" v-model="building.data.additionalValues"
                                                        :multiple="true"
                                                        placeholder="Танланг..." label="name"
                                                        :options="preparedAdditionalValues">
                                            </treeselect>
                                        </div>

                                        <div class="form-group" >
                                            <label>Эскириш <span class="red">*</span></label>
                                            <select class="form-control" v-model="building.technicalCondition"
                                                    @change="onChangeTechnicalCondition"
                                                    :class="{invalid : $v.building.technicalCondition.$error}">
                                                <option value=""></option>
                                                <option :value="option.key" v-for="option in technicalConditions"
                                                        :key="`technical-condition-${option.key}`">
                                                    {{option.name}}
                                                </option>
                                            </select>
                                            <div class="red" v-if="$v.building.technicalCondition.$error">
                                                {{$t("auto.technicalConditionOfCar")}}
                                            </div>
                                        </div>
                                        <div class="form-group" >
                                            <label>{{$t("auto.dilapidationValueByExpert")}} <span
                                                    class="red">*</span></label>
                                            <select class="form-control" v-model="building.dilapidationValueByExpert"
                                                    @change="onDilapidationChange"
                                                    :class="{invalid : $v.building.dilapidationValueByExpert.$error}">
                                                <option value=""></option>
                                                <option :value="option.key" v-for="option in dilapidationLookupData"
                                                        :key="`dilapidation-value-by-expert-${option.key}`">
                                                    {{option.name}}
                                                </option>
                                            </select>
                                            <div class="red" v-if="$v.building.dilapidationValueByExpert.$error">
                                                {{$t("auto.dilapidationValueByExpert")}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="building.cadastreBuilding">
                                    <div class="col-12">
                                        <div class="section-header">
                                            <h4 class="pull-left">
                                                {{$t("building.field.depreciation")}}
                                            </h4>
                                        </div>
                                    </div>
                                    <div class="col-12 table-responsive" v-if="checkedDepreciationFields.length > 0">
                                        <div class="table-wrapper">
                                          <table class="table table-striped">
                                              <thead>
                                              <tr>
                                                  <th width="30%">Конструктив элемент</th>
                                                  <th width="10%" class="text-right">Хисоб огирлиги</th>
                                                  <th width="15%" class="text-center">Хисоб огирлигига узгартириш</th>
                                                  <th width="15%" class="text-right">Кейинги хисоб огирлик</th>
                                                  <th width="15%" class="text-center">Емирилиш (%)</th>
                                                  <th width="15%" class="text-right"
                                                      style="width: 100%;padding: 12px 8px">Хисобий емирилиш
                                                  </th>
                                              </tr>
                                              </thead>
                                              <tbody>
                                              <tr v-for="field in checkedDepreciationFields" :key="`checked-depreciation-fields-${field.code}`">
                                                  <td>{{field.name}}</td>
                                                  <td class="text-right">{{field.weight | currency('', 2, {
                                                      thousandsSeparator: ' ' })}}
                                                  </td>
                                                  <td class="text-center" style="padding: 1px 8px;">
                                                      <numeric-input style="width: 100px !important; margin: 0 auto"
                                                                     v-model="field.change"
                                                                     :precision="2" align="center"
                                                                     :max="field.weight"></numeric-input>
                                                  </td>
                                                  <td class="text-right">{{field.next | currency('', 2, {
                                                      thousandsSeparator: ' ' })}}
                                                  </td>
                                                  <td class="text-center" style="padding: 1px 8px;">
                                                      <numeric-input style="width: 100px !important; margin: 0 auto"
                                                                     :precision="2" align="center"
                                                                     v-model="field.erosion" :max="100"></numeric-input>
                                                  </td>
                                                  <td class="text-right">{{field.calculated | currency('', 2, {
                                                      thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr class="bold-row">
                                                  <td>Жами:</td>
                                                  <td class="text-right">{{calculatedAll.calculated.depreciation.weight |
                                                      currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                                  <td class="text-center">{{calculatedAll.calculated.depreciation.change |
                                                      currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                                  <td class="text-right">{{calculatedAll.calculated.depreciation.next |
                                                      currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                                  <td></td>
                                                  <td class="text-right">
                                                      {{calculatedAll.calculated.depreciation.calculated |
                                                      currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              </tbody>
                                          </table>
                                        </div>
                                    </div>
                                    <div class="col-6" v-else-if="isDepreciationPercent">
                                        <div class="form-group">
                                            <label>{{$t("building.field.depreciationConstructiveElements")}} <span
                                                    class="red">*</span></label>
                                            <numeric-input v-model="building.depreciationPercent" :precision="2"
                                                           :max="100"
                                                           :class="{invalid : $v.building.depreciationPercent.$error}"></numeric-input>
                                            <div class="red" v-if="$v.building.depreciationPercent.$error">
                                                {{$t("building.validation.depreciationPercent")}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="section-header">
                                            <h4 class="pull-left">
                                                {{$t("building.field.photosToSubmit")}}
                                            </h4>
                                        </div>
                                    </div>
                                    <RealEstateDropZone :code="`buildingPhotoDropZone_${index + 1}`" folder="Building"
                                                        view="BUILDING" :data="building.photos"
                                                        @change="(photos) => {building.photos = photos}"
                                                        :has-error="$v.building.photos.$error"
                                                        :removeFile="(buildingId && buildingId > 0) && isRemoveFile"
                                                        :editable="isEditableFile"
                                    />
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </div>
            </div>
        </div>
        <NewRealEstateBuildingCalculatedView :buildingId="buildingId"></NewRealEstateBuildingCalculatedView>
        <CadastreBuildingSelectModal :index="buildingId"
                                     :building="building"
                                     :cadastreBuildingFields="cadastreBuildingFields"
                                     :cadastreBuildingFieldReferences="cadastreBuildingFieldReferences"
        ></CadastreBuildingSelectModal>
    </div>
</template>

<script>
    /* eslint-disable no-unused-vars */

    import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
    import {VBToggle} from 'bootstrap-vue/es/directives/toggle/toggle'
    import {required, requiredUnless, minValue, minLength} from 'vuelidate/lib/validators';
    import {numericTypes} from '@/shared/constants/mask';
    import initFilterModel from '@/shared/filter';
    import RealEstateDropZone from '@/views/real-estate/RealEstateDropZone';
    import {TECHNICAL_CONDITION} from '@/shared/constants/real-estate'
    import {formatDate, parseDate} from '@/shared/utils';
    import Treeselect from '@riophae/vue-treeselect';
    import NewRealEstateBuildingCalculatedView from '@/views/real-estate/new/NewRealEstateBuildingCalculatedView';
    import Datepicker from 'vuejs-datepicker';
    import CadastreBuildingSelectModal from './CadastreBuildingSelectModal'
    import {calculateFieldErosion} from '@/shared/calculateDepreciationFieldErosion'

    export default {
        props: {
            buildingId: {
                default: null
            },
            index: {
                default: 0
            },
            isRemoveFile: {
                type: Boolean,
                default: false
            },
            isEditableFile: {
                type: Boolean,
                default: false
            },
            // asIncomeValid: {
            //     type: Boolean,
            //     default: false
            // }
            approachCost: {
                type: Boolean,
                default: false
            }
        },
        components: {
            BCollapse,
            Treeselect,
            RealEstateDropZone,
            NewRealEstateBuildingCalculatedView,
            Datepicker,
            CadastreBuildingSelectModal
        },
        directives: {
            'b-toggle': VBToggle
        },
        data() {
            return {
                modelLastChangeTime: new Date().getTime(),
                numericTypes: numericTypes,
                cadastreSectionFilter: initFilterModel(),
                buildingsToAttachFilter: initFilterModel(),
                processing: false,
                realEstate: null,
                parentName: ((this.$route.params.hasOwnProperty('parentName') && this.$route.params.parentName) ? ('/' + this.$route.params.parentName + '/') : '/'),
                building: {
                    id: null,
                    realEstateId: ((this.$route.params.id && this.$route.params.id > 0) ? this.$route.params.id : null),
                    cadastreBuilding: null,
                    cadastreBuildingCategory: 'a',
                    cadastreBuildingCategoryVol: null,
                    name: '',
                    madeYear: null,
                    floors: null,
                    area: null,
                    height: null,
                    heightInner: null,
                    volume: null,
                    earthquakePoint: 7,
                    businessCoefficient: null,
                    depreciationPercent: 0,
                    // auxiliaryBuilding: false,
                    data: {
                        values: {},
                        additionalValues: []
                    },
                    photos: [],
                    calculated: {},
                    dilapidationValueByExpert: 0,
                    hasManualVolume: false,
                    hasComparative: false,
                    // newIncome: {},
                    isNotExist: false,
                    isNotEvaluated: false
                },
                coefficient: {
                    index: [],
                    earthquake: [],
                    regional: [],
                    capital: [],
                    height: [],
                    volume: [],
                    business: []
                },
                cadastreBuildings: [],
                cadastreBuildingFields: [],
                cadastreBuildingFieldReferences: {},
                cadastreBuildingDepreciationFields: [],
                buildingsToAttach: [],
                references: {},
                formDefault: {
                    fields: ["name", "made_year", "floors", "area", "height", "volume", "earthquake_point", "business_coefficient",
                        "foundation", "wall", "house_top", "house_cover", "floor_type", "window_and_doors", "window", "door", "half_timbers", "columns_and_pillars", "electrical_devices"]
                },
                maxMadeYear: new Date().getFullYear(),
                dilapidationLookupData: [],
                technicalConditions: TECHNICAL_CONDITION,
                cadastreData: {},
                isAddValueCollapse: false,
                // incomeKkCoefficients: [],
                // incomeKxCoefficients: [],
                // incomeKtCoefficients: [],
                // comparison: {
                //     purposeRentingId: null,
                //     rentArea: 0,
                //     coefficientOfConstruction: null,
                //     coefficientOfConnectedArea: null,
                //     coefficientOfCommercialGoal: null
                // },
                // purposeRentingAreas: [],
                // incomeFilter: initFilterModel(),
                // approachIncome: false
            }
        },
        validations() {
            return {
                building: {
                    realEstateId: {
                        required: required
                    },
                    cadastreBuilding: {
                        required: requiredUnless(()=> {
                            return this.isSentToComplement || !this.isApproachCost
                        })
                    },
                    name: {
                        required: required
                    },
                    floors: {
                        required: requiredUnless(() => {
                            return !(this.hasField('floors')) || !this.isApproachCost;
                        }),
                        minValue: minValue(this.hasField('floors') ? 0.01 : 0)
                    },
                    area: {
                        required: requiredUnless(() => {
                            return !(this.hasField('area')) || !this.isApproachCost;
                        }),
                        minValue: minValue(this.hasField('area') ? 0.01 : 0)
                    },
                    height: {
                        required: requiredUnless(() => {
                            return !(this.hasField('height')) || !this.isApproachCost;
                        }),
                        minValue: minValue(this.hasField('height') ? 0.01 : 0)
                    },
                    volume: {
                        required: requiredUnless(() => {
                            return !(this.hasField('volume')) || !this.isApproachCost;
                        }),
                        minValue: minValue(this.hasField('volume') ? 0.01 : 0)
                    },
                    earthquakePoint: {
                        required: requiredUnless(() => {
                            return !(this.hasField('earthquake_point')) || !this.isApproachCost
                        }),
                        minValue: minValue(0.01)
                    },
                    businessCoefficient: {
                        required: requiredUnless(() => {
                            return !this.isApproachCost
                        }),
                        minValue: minValue(0.01)
                    },
                    depreciationPercent: {
                        required: requiredUnless(() => {
                            return !(this.isDepreciationPercent);
                        })
                    },
                    technicalCondition: {
                        required: requiredUnless(() =>{
                            return !!(this.hasGreenSpaces) || !this.isApproachCost
                        })
                    },
                    dilapidationValueByExpert: {
                        required: required
                    },
                    photos: {
                        required: requiredUnless(()=> {
                            return this.isSentToComplement
                        }),
                        minLength: minLength(1)
                    }
                    // parent: {
                    //     required: requiredUnless(() => {
                    //         return !(this.building.auxiliaryBuilding);
                    //     })
                    // }
                },
                cadastreBuildingFields: {
                    $each: {
                        value: {
                            required: requiredUnless(vm => {
                                return !(!vm.system && this.hasField(vm.code) && vm.required) || !this.isApproachCost;
                            })
                        }
                    }
                },
                /* comparison: {
                     rentArea: {
                         required: requiredUnless(() => {
                             return !(this.isValidIncome);
                         }),
                         minValue: minValue(this.getRentAreaMinValue)
                     },
                     purposeRentingId: {
                         required: requiredUnless(() => {
                             return !(this.isValidIncome && !this.isOwnerTypePhysical);
                         }),
                     },
                     coefficientOfConstruction: {
                         required: requiredUnless(() => {
                             return !(this.isValidIncome && !this.isOwnerTypePhysical);
                         }),
                     },
                     coefficientOfConnectedArea: {
                         required: requiredUnless(() => {
                             return !(this.isValidIncome && !this.isOwnerTypePhysical);
                         }),
                     },
                     coefficientOfCommercialGoal: {
                         required: requiredUnless(() => {
                             return !(this.isValidIncome && !this.isOwnerTypePhysical);
                         }),
                     }
                 } */
            };
        },
        computed: {
            /*getRentAreaMinValue() {
                return this.approachIncome && this.asIncomeValid ? 0.01 : 0
            }, */
            hasGreenSpaces() {
                return this.building && this.building.cadastreBuilding && this.building.cadastreBuilding.cadastreSection.code === "GreenSpaces";
            },
            isCategorySelectableAndHasCategories() {
                return this.building.cadastreBuilding
                    && this.building.cadastreBuilding.chooseCategory
                    && this.building.cadastreBuilding.data
                    && this.building.cadastreBuilding.data.category
                    && this.building.cadastreBuilding.data.category.codes
                    && this.building.cadastreBuilding.data.category.codes.length > 0;
            },
            checkedCustomFields() {
                return this.cadastreBuildingFields.filter((field) => {
                    return !field.system && this.hasField(field.code);
                });
            },
            checkedDepreciationFields() {
                if (this.building && this.building.cadastreBuilding && this.building.cadastreBuilding.id && this.building.cadastreBuilding.id > 0) {
                    if (this.building.cadastreBuilding.data
                        && this.building.cadastreBuilding.data.depreciation
                        && this.building.cadastreBuilding.data.depreciation.codes
                        && this.building.cadastreBuilding.data.depreciation.codes.length > 0) {
                        return this.cadastreBuildingDepreciationFields.filter((field) => {
                            return this.building.cadastreBuilding.data.depreciation.codes.includes(field.code);
                        });
                    } else {
                        return [];
                    }
                } else {
                    return [];
                }
            },
            filteredEarthquakePoints() {
                let buildingType = 'Civil';
                let buildingCategory = 'Notorious';
                let book = 1;
                if (this.building.cadastreBuilding) {
                    if (this.building.cadastreBuilding.buildingType && this.building.cadastreBuilding.buildingType.length > 0) {
                        buildingType = this.building.cadastreBuilding.buildingType;
                    }
                    if (this.building.cadastreBuilding.buildingCategory && this.building.cadastreBuilding.buildingCategory.length > 0) {
                        buildingCategory = this.building.cadastreBuilding.buildingCategory;
                    }
                    if (this.building.cadastreBuilding.cadastreSection && this.building.cadastreBuilding.cadastreSection.book) {
                        book = this.building.cadastreBuilding.cadastreSection.book;
                    }
                }
                return this.coefficient.earthquake.filter((item) => {
                    return item.type === buildingType && item.category === buildingCategory && item.book === book;
                });
            },
            preparedAdditionalValues() {
                if (this.building && this.building.cadastreBuilding && this.building.cadastreBuilding.data && this.building.cadastreBuilding.data.additionalValues) {
                    const category_code = this.calculatedAll.category.code;
                    if (category_code && category_code.length > 0) {
                        return this.building.cadastreBuilding.data.additionalValues.map((value => {
                            let label = value.name;
                            if (value.values && value.values.hasOwnProperty(category_code) && value.values[category_code]) {
                                label += '(' + value.values[category_code] + ')';
                            }
                            return {
                                id: value.code,
                                label: label
                            };
                        }));
                    }
                }
                return [];
            },
            calculatedAll() {
                //CADASTRE BUILDING CATEGORY CALCULATION
                let cbCategoryCode = '';
                let cbCategoryVol = null;
                let cbCategoryVolDefault = null;
                const cb = this.building.cadastreBuilding;
                const system_number_fields = ['made_year', 'floors', 'area', 'height', 'height_inner', 'volume'];
                const system_number_fields_code = ['madeYear', 'floors', 'area', 'height', 'heightInner', 'volume'];
                if (cb) {
                    if (cb.hasOwnProperty('chooseCategory') && cb.chooseCategory) {
                        cbCategoryCode = this.building.cadastreBuildingCategory;
                    } else if (cb.data && cb.data.category && cb.data.category.settings) {
                        Object.keys(cb.data.category.settings).forEach((category_code) => {
                            const category_settings = cb.data.category.settings[category_code];
                            const category_criteria = category_settings.criteria;
                            let category_volume = null;
                            if (category_criteria && category_criteria.length > 0) {
                                let has_not_matched_items = false;
                                category_criteria.forEach((criteria) => {
                                    const field_code = criteria.field;
                                    const field_index = system_number_fields.indexOf(field_code);
                                    if (field_index >= 0) {
                                        const value = this.building[system_number_fields_code[field_index]];
                                        if ((criteria.valueMin && value < criteria.valueMin) || (criteria.valueMax && value > criteria.valueMax)) {
                                            has_not_matched_items = true;
                                        }
                                        if (field_code === 'volume') {
                                            category_volume = criteria.valueMax;
                                            if (category_code === 'a') {
                                                cbCategoryVolDefault = criteria.valueMax;
                                            }
                                        }
                                    } else {
                                        const custom_fields = this.cadastreBuildingFields.filter((field) => field.code === field_code);
                                        if (custom_fields && custom_fields.length > 0) {
                                            const custom_field = custom_fields[0];
                                            if (this.building.data && this.building.data.values && this.building.data.values.hasOwnProperty(custom_field.code)) {
                                                const custom_field_data = this.building.data.values[custom_field.code];
                                                if (custom_field.type === 'INTEGER' || custom_field.type === 'DECIMAL') {
                                                    const value = custom_field_data;
                                                    if ((criteria.valueMin && value < criteria.valueMin) || (criteria.valueMax && value > criteria.valueMax)) {
                                                        has_not_matched_items = true;
                                                    }
                                                } else if (custom_field.type === 'COMBOBOX' || custom_field.type === 'LISTBOX') {
                                                    if (custom_field_data && custom_field_data.code) {
                                                        if (custom_field_data.code !== criteria.value) {
                                                            has_not_matched_items = true;
                                                        }
                                                    }
                                                } else {
                                                    if (custom_field_data) {
                                                        if (custom_field_data !== criteria.value) {
                                                            has_not_matched_items = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                });
                                if (!has_not_matched_items) {
                                    cbCategoryCode = category_code;
                                    cbCategoryVol = category_volume;
                                }
                            }
                        });
                    }
                }

                if (cbCategoryCode === '') {
                    cbCategoryCode = 'a';
                    cbCategoryVol = cbCategoryVolDefault;
                }

                //DEPRECIATION TOTAL CALCULATIONS
                let totalDepreciationWeight = 0;
                let totalDepreciationChange = 0;
                let totalDepreciationNext = 0;
                let totalDepreciationCalculated = 0;

                // console.log('checked_depreciation_fields_count:' + this.checkedDepreciationFields.length);

                if (this.checkedDepreciationFields.length > 0) {
                    const vm = this;
                    this.checkedDepreciationFields.forEach((field) => {
                        let weight = 0;
                        if (vm.building.cadastreBuilding && vm.building.cadastreBuilding.data && vm.building.cadastreBuilding.data.depreciation
                            && vm.building.cadastreBuilding.data.depreciation.weights
                            && vm.building.cadastreBuilding.data.depreciation.weights.hasOwnProperty(field.code)
                            && vm.building.cadastreBuilding.data.depreciation.weights[field.code]
                            && vm.building.cadastreBuilding.data.depreciation.weights[field.code].hasOwnProperty(cbCategoryCode)
                            && vm.building.cadastreBuilding.data.depreciation.weights[field.code][cbCategoryCode]) {
                            weight = vm.building.cadastreBuilding.data.depreciation.weights[field.code][cbCategoryCode];
                            // console.log('weight:' + field.name + ':' + weight);
                        }
                        /* else {
                                                    console.log('weight_not_found:' + field.name);
                                                }*/
                        field.weight = ((weight && weight > 0) ? weight : 0);
                        field.change = ((field.change && field.change > 0) ? field.change : 0);
                        field.next = (weight >= field.change ? (weight - field.change) : 0);

                        field.calculated = (field.next * field.erosion) / 100;

                        totalDepreciationWeight += ((field.weight && field.weight > 0) ? field.weight : 0);
                        totalDepreciationChange += ((field.change && field.change > 0) ? field.change : 0);
                        totalDepreciationNext += ((field.next && field.next > 0) ? field.next : 0);
                        totalDepreciationCalculated += ((field.calculated && field.calculated > 0) ? field.calculated : 0);
                    });
                } else {
                    totalDepreciationNext = 100;
                    totalDepreciationCalculated = (this.building.depreciationPercent ? this.building.depreciationPercent : 0);
                }

                // recovery price calculation
                let recoveryPriceUnit = 'volume';
                let recoveryPriceUnitValue = null;
                let recoveryPricePerUnit = 0;
                // const categoryCode = this.building.cadastreBuildingCategory;
                if (cb && cb.data) {
                    if (cb.data.recoveryFieldCode && cb.data.recoveryFieldCode.length > 0) {
                        recoveryPriceUnit = cb.data.recoveryFieldCode;
                    }
                    if (cb.data.category && cb.data.category.settings
                        && cb.data.category.settings.hasOwnProperty(cbCategoryCode)
                        && cb.data.category.settings[cbCategoryCode] && cb.data.category.settings[cbCategoryCode].recoveryPrice) {
                        recoveryPricePerUnit = cb.data.category.settings[cbCategoryCode].recoveryPrice;
                    }
                    // if (cb.data.additionalValues && cb.data.additionalValues.length > 0) {
                    //     const addValuesChecked = cb.data.additionalValues.filter((value) => {
                    //         return this.building.data.additionalValues.indexOf(value.code) >= 0;
                    //     });
                    //     if (addValuesChecked.length > 0) {
                    //         addValuesChecked.forEach((value) => {
                    //             if (value.values && value.values.hasOwnProperty(cbCategoryCode) && value.values[cbCategoryCode] && value.values[cbCategoryCode] > 0) {
                    //                 recoveryPricePerUnit += value.values[cbCategoryCode];
                    //             }
                    //         });
                    //     }
                    // }
                }
                if (recoveryPriceUnit === 'volume') {
                    recoveryPriceUnitValue = this.building.volume;
                } else if (recoveryPriceUnit === 'height') {
                    recoveryPriceUnitValue = this.building.height;
                } else if (recoveryPriceUnit === 'height_inner') {
                    recoveryPriceUnitValue = this.building.heightInner;
                } else if (recoveryPriceUnit === 'floors') {
                    recoveryPriceUnitValue = this.building.floors;
                } else if (recoveryPriceUnit === 'area') {
                    recoveryPriceUnitValue = this.building.area;
                } else if (recoveryPriceUnit === 'earthquake_point') {
                    recoveryPriceUnitValue = this.building.earthquakePoint;
                } else if (recoveryPriceUnit === 'business_coefficient') {
                    recoveryPriceUnitValue = this.building.businessCoefficient;
                } else {
                    const custom_fields = this.cadastreBuildingFields.filter((field) => field.code === recoveryPriceUnit);
                    if (custom_fields && custom_fields.length > 0) {
                        const custom_field = custom_fields[0];
                        if ((custom_field.type === 'INTEGER' || custom_field.type === 'DECIMAL') && custom_field.value && custom_field.value > 0) {
                            recoveryPriceUnitValue = custom_field.value;
                        } else if (custom_field.type === 'LISTBOX' && custom_field.value && custom_field.value.length > 0) {
                            recoveryPriceUnitValue = parseFloat(custom_field.value);
                        } else if (custom_field.type === 'COMBOBOX' && custom_field.selected && custom_field.selected.code && custom_field.selected.code.length > 0) {
                            recoveryPriceUnitValue = parseFloat(custom_field.selected.code);
                        }
                    }
                }

                // constructive change value calculation
                let constructiveChange = (totalDepreciationNext * recoveryPricePerUnit) / 100;

                if (cb && cb.data) {
                    if (cb.data.additionalValues && cb.data.additionalValues.length > 0) {
                        const addValuesChecked = cb.data.additionalValues.filter((value) => {
                            return this.building.data.additionalValues.indexOf(value.code) >= 0;
                        });
                        if (addValuesChecked.length > 0) {
                            addValuesChecked.forEach((value) => {
                                if (value.values && value.values.hasOwnProperty(cbCategoryCode) && value.values[cbCategoryCode] && value.values[cbCategoryCode] > 0) {
                                    constructiveChange += value.values[cbCategoryCode];
                                }
                            });
                        }
                    }
                }

                // recover price 1991 calculation
                let recoveryPrice1991 = 0;
                if (recoveryPriceUnitValue) {
                    recoveryPrice1991 = constructiveChange * recoveryPriceUnitValue;
                }

                // BUILDING PRICE CALCULATION START
                // building price calculation before coefficients
                let priceBuilding = recoveryPrice1991;
                if (this.coefficient && this.coefficient.index && this.coefficient.index.length > 0) {
                    this.coefficient.index.forEach((index) => {
                        if (index.value) {
                            priceBuilding = priceBuilding * index.value;
                        }
                    });
                }
                //building price calculation - earthquake coefficient
                let book = 1;
                if (this.building.cadastreBuilding && this.building.cadastreBuilding.cadastreSection && this.building.cadastreBuilding.cadastreSection.book) {
                    book = this.building.cadastreBuilding.cadastreSection.book;
                }

                let coefficientEarthQuake = 1;

                if (this.building.cadastreBuilding && this.building.cadastreBuilding.buildingType && this.building.earthquakePoint && !this.building.cadastreBuilding.earthquakePointEnabled) {
                    const items = this.coefficient.earthquake.filter((item) => {
                        return item.type === this.building.cadastreBuilding.buildingType
                            && item.category === this.building.cadastreBuilding.buildingCategory
                            && item.points === this.building.earthquakePoint && item.book === book;
                    });
                    if (items.length > 0) {
                        coefficientEarthQuake = items[0].value;
                    }
                }
                priceBuilding = priceBuilding * coefficientEarthQuake;

                //building price calculation - regional coefficient
                let coefficientRegional = 1;
                if (this.building && this.building.cadastreBuilding && this.building.cadastreBuilding
                    && this.building.cadastreBuilding.section && this.building.cadastreBuilding.section.book
                    && this.realEstate.province && this.realEstate.province.id) {
                    const regional_items = this.coefficient.regional.filter((item) => {
                        return item.book === this.building.cadastreBuilding.section.book && item.provinceId === this.realEstate.province.id && item.book === book;
                    });
                    if (regional_items.length >= 1) {
                        coefficientRegional = regional_items[0].value;
                    }
                }
                priceBuilding = priceBuilding * coefficientRegional;

                //building price calculation - capital coefficient
                let coefficientCapital = 1;
                if (this.building && this.building.cadastreBuilding) {
                    let capitals_map = {
                        "I": {value: 1, weight: 0},
                        "II": {value: 2, weight: 0},
                        "III": {value: 3, weight: 0},
                        "IV": {value: 4, weight: 0},
                        "V": {value: 5, weight: 0}
                    };
                    let book_capital_group;
                    const cBuilding = this.building.cadastreBuilding;
                    const cBuildingCategory = this.building.cadastreBuildingCategory;
                    if (cBuilding && cBuilding.data) {
                        let capitalGroupCode;
                        if (cBuilding.data.capitalGroupByCategory) {
                            if (cBuildingCategory && cBuildingCategory.length > 0
                                && cBuilding.data.category && cBuilding.data.category.settings
                                && cBuilding.data.category.settings.hasOwnProperty(cBuildingCategory)) {
                                const categorySettings = cBuilding.data.category.settings[cBuildingCategory];
                                if (categorySettings && categorySettings.hasOwnProperty('capitalGroup')) {
                                    capitalGroupCode = categorySettings['capitalGroup'];
                                }
                            }
                        } else {
                            if (cBuilding.data.capitalGroup && cBuilding.data.capitalGroup.length > 0) {
                                capitalGroupCode = cBuilding.data.capitalGroup;
                            }
                        }
                        if (capitalGroupCode && capitalGroupCode.length > 0 && capitals_map.hasOwnProperty(capitalGroupCode)) {
                            book_capital_group = capitals_map[capitalGroupCode].value;
                        }
                    }

                    if (book_capital_group && book_capital_group > 0) {
                        let calculated_max_weight = 0;
                        let calculated_capital_group;

                        let capitals_key = 'capitals';
                        if (this.building.cadastreBuilding && this.building.cadastreBuilding.buildingCategory
                            && this.building.cadastreBuilding.buildingCategory === 'Residential') {
                            capitals_key = 'capitals_residential';
                        }

                        this.cadastreBuildingFields.forEach((field) => {
                            if (field.data && field.data.values && field.data.values.hasOwnProperty('capital_weight')) {
                                const weight = field.data.values['capital_weight'];
                                if (field.selected && field.selected.data && field.selected.data.values && field.selected.data.values.hasOwnProperty(capitals_key)) {
                                    const capitals = field.selected.data.values[capitals_key];
                                    if (capitals && capitals.length > 0) {
                                        capitals.forEach((capital) => {
                                            if (capitals_map.hasOwnProperty(capital)) {
                                                capitals_map[capital].weight += weight;
                                                if (capitals_map[capital].weight > calculated_max_weight) {
                                                    calculated_max_weight = capitals_map[capital].weight;
                                                    calculated_capital_group = capitals_map[capital].value
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        });
                        if (!calculated_capital_group) {
                            calculated_capital_group = book_capital_group;
                        }
                        if (calculated_capital_group) {
                            let building_category = 'Notorious';
                            if (this.building.cadastreBuilding && this.building.cadastreBuilding.buildingCategory
                                && this.building.cadastreBuilding.buildingCategory.length > 0) {
                                building_category = this.building.cadastreBuilding.buildingCategory;
                            }
                            const capital_items = this.coefficient.capital.filter((item) => {
                                return item.bookGroup === book_capital_group
                                    && item.buildingGroup === calculated_capital_group
                                    && item.category === building_category;
                            });
                            if (capital_items.length > 0) {
                                coefficientCapital = capital_items[0].value;
                            }
                        }
                    }
                }
                priceBuilding = priceBuilding * coefficientCapital;

                //building price calculation - height coefficient
                let coefficientHeight = 1;
                if (this.building.cadastreBuilding && this.building.cadastreBuilding.buildingType
                    && this.building.cadastreBuilding.buildingType === 'Civil'
                    && this.building.heightInner && this.building.heightInner > 0) {
                    let lastAcceptableHeight;
                    this.coefficient.height.forEach((height) => {
                        if (height.height <= this.building.heightInner) {
                            lastAcceptableHeight = height;
                        } else {
                            coefficientHeight = 1.06
                        }
                    });
                    if (lastAcceptableHeight) {
                        coefficientHeight = lastAcceptableHeight.value;
                    }
                }
                priceBuilding = priceBuilding * coefficientHeight;

                //building price calculation - volume coefficient
                let coefficientVolume = 1;
                if (this.building.cadastreBuildingCategoryVol && this.building.cadastreBuildingCategoryVol >= 0 && this.building.volume && this.building.volume >= 0) {
                    this.coefficient.volume.forEach((bookVol) => {
                        if (this.building.cadastreBuildingCategoryVol >= bookVol.min && this.building.cadastreBuildingCategoryVol <= bookVol.max) {
                            if (bookVol.items && bookVol.items.length > 0) {
                                bookVol.items.forEach((evlVol) => {
                                    if (this.building.volume >= evlVol.min && this.building.volume <= evlVol.max) {
                                        coefficientVolume = evlVol.coefficient;
                                    }
                                });
                            }
                        }
                    });
                }
                priceBuilding = priceBuilding * coefficientVolume;

                // //building price calculation - business coefficient
                priceBuilding = priceBuilding * this.building.businessCoefficient;
                // BUILDING PRICE CALCULATION END

                //DEPRECIATION CALCULATION START
                let calculatedDepreciationPercent = 0;
                let calculatedDepreciationTotal = 0;
                if (totalDepreciationNext && totalDepreciationNext > 0) {
                    calculatedDepreciationPercent = (totalDepreciationCalculated * 100) / totalDepreciationNext;
                    // calculatedDepreciationPercent = totalDepreciationCalculated;
                    calculatedDepreciationTotal = parseFloat(priceBuilding.toFixed(2)) * parseFloat(calculatedDepreciationPercent.toFixed(2)) / 100;
                }
                //DEPRECIATION CALCULATION END

                // //PRICE CALCULATION - EXPENSE METHOD
                const priceExpense = priceBuilding - calculatedDepreciationTotal;

                return {
                    modelLastChangeTime: this.modelLastChangeTime,
                    category: {
                        code: cbCategoryCode,
                        volume: cbCategoryVol
                    },
                    calculated: {
                        constructive: {
                            change: constructiveChange
                        },
                        recovery: {
                            unit: 'volume',
                            pricePerUnit: recoveryPricePerUnit,
                            price1991: recoveryPrice1991
                        },
                        coefficient: {
                            earthquake: coefficientEarthQuake,
                            regional: coefficientRegional,
                            capital: coefficientCapital,
                            height: coefficientHeight,
                            volume: coefficientVolume,
                            business: this.building.businessCoefficient
                        },
                        depreciation: {
                            weight: totalDepreciationWeight,
                            change: totalDepreciationChange,
                            next: totalDepreciationNext,
                            calculated: totalDepreciationCalculated,
                            percent: calculatedDepreciationPercent,
                            total: calculatedDepreciationTotal
                        },
                        price: {
                            building: priceBuilding,
                            expense: priceExpense,
                            income: 0,
                            comparative: 0
                        }
                    }
                };
            },
            isDepreciationPercent() {
                return this.building
                    && this.building.cadastreBuilding
                    && this.building.cadastreBuilding.id
                    && this.building.cadastreBuilding.id > 0
                    && this.building.cadastreBuilding.totalDepreciation;
            },
            canSave() {
                return this.realEstate && (this.realEstate.status === 'Pending' || this.realEstate.status === 'AssignedToEvaluator'
                    || this.realEstate.status === 'NotFullyEvaluated' || this.realEstate.status === 'SentToComplement' || this.realEstate.status === 'ErrorInPrice')
                    && this.hasEvaluation
            },
            isOwnerTypePhysical() {
                return !!(this.realEstate.owner && this.realEstate.owner.type && this.realEstate.owner.type === 'Physical');
            },
            isSentToComplement() {
                return !!(this.realEstate && this.realEstate.status === 'SentToComplement')
            },
            isApproachCost() {
                return this.approachCost
            },
            hasEvaluation() {
              return !this.building.isNotExist && !this.building.isNotEvaluated;
            },
            isFieldDisabled() {
              return process.env.VUE_APP_NAME === "dev"
                  || process.env.VUE_APP_NAME === "staging"
                  || process.env.VUE_APP_NAME === "production"
                  || process.env.VUE_APP_NAME === "office"
            }
        },
        methods: {
            init() {
                const vm = this;
                const promises = [
                    this.$http.get('new-real-estate/' + this.building.realEstateId + '/building/init')
                ];
                if (this.buildingId && this.buildingId > 0) {
                    promises.push(this.$http.get('new-real-estate/building/' + this.buildingId));
                }
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.realEstate = initData.realEstate;
                    vm.approachIncome = initData.approachIncome;
                    vm.coefficient = initData.coefficient;
                    vm.cadastreBuildingFields = initData.fields;
                    vm.cadastreBuildingFieldReferences = initData.references;
                    vm.cadastreBuildingDepreciationFields = initData.depreciation.map((field) => {
                        field.weight = 0;
                        field.change = 0;
                        field.erosion = 0;
                        return field;
                    });
                    vm.purposeRentingAreas = initData.purposeRentingAreas;
                    if (values.length >= 2) {
                        const formData = values[1].data;
                        if (formData && formData.settings && formData.settings.indexes && formData.settings.indexes.length > 0) {
                            vm.coefficient.index = formData.settings.indexes;
                        }
                        // if (formData.parent && formData.parent.id && formData.parent.id > 0) {
                        //     formData.auxiliaryBuilding = true;
                        // }
                        if (formData.data && formData.data.values) {
                            vm.cadastreBuildingFields.forEach((field) => {
                                if (field.code && !field.system && formData.data.values.hasOwnProperty(field.code)) {
                                    const fieldValue = formData.data.values[field.code];
                                    if (fieldValue) {
                                        if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                                            if (fieldValue.id && fieldValue.id > 0) {
                                                field.value = fieldValue.id;
                                                field.selected = vm.getReferenceById(field.reference.code, fieldValue.id);
                                            }
                                        } else if (field.type === 'MULTISELECT') {
                                            if (fieldValue) {
                                                field.selected = [];
                                                if (fieldValue.length > 0) {
                                                    fieldValue.forEach((ref) => {
                                                        field.selected.push(ref.id);
                                                    });
                                                } else if (fieldValue.hasOwnProperty('id') && fieldValue.id && fieldValue.id > 0) {
                                                    field.selected.push(fieldValue.id);
                                                }
                                                field.value = field.selected;
                                            }
                                        } else if (field.type === 'DATE_PICKER') {
                                            if (fieldValue) {
                                                field.date = parseDate(fieldValue);
                                            }
                                        } else {
                                            field.value = fieldValue;
                                        }
                                    }
                                }
                            });
                            if (formData.depreciations && formData.depreciations.length > 0) {
                                vm.cadastreBuildingDepreciationFields.forEach((field) => {
                                    formData.depreciations.forEach((depreciation) => {
                                        if (depreciation.field && depreciation.field.id && depreciation.field.id === field.id) {
                                            field.weight = depreciation.weight;
                                            field.change = depreciation.change;
                                            field.erosion = depreciation.erosion;
                                        }
                                    });
                                });
                            }
                        }
                        if (!formData.data) {
                            formData.data = {};
                        }
                        if (!formData.data.values) {
                            formData.data.values = {};
                        }
                        if (!formData.data.additionalValues) {
                            formData.data.additionalValues = [];
                        }
                        if (formData.newIncome) {
                            vm.comparison = {
                                purposeRentingId: formData.newIncome.purposeRentingId,
                                rentArea: formData.newIncome.rentArea,
                                coefficientOfConstruction: formData.newIncome.coefficientOfConstruction,
                                coefficientOfConnectedArea: formData.newIncome.coefficientOfConnectedArea,
                                coefficientOfCommercialGoal: formData.newIncome.coefficientOfCommercialGoal
                            }
                        }
                        vm.building = formData;
                        vm.$emit('handle-building-photos', vm.building.photos)
                        vm.calculateVolume();
                    }
                   /* if (initData.realEstate.cadastreData) {
                        vm.calculateCadastreBuildingData(initData.realEstate.cadastreData)
                    } */
                    vm.onChangeTechnicalCondition();
                });
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                // this.building.data = {
                //     values: this.customDataValues
                // };

                // if (!this.building.auxiliaryBuilding) {
                //     this.building.parent = null;
                // }
                this.building.depreciations = [];
                this.checkedDepreciationFields.forEach((field) => {
                    this.building.depreciations.push({
                        field: {
                            id: field.id,
                        },
                        weight: field.weight,
                        change: field.change,
                        next: field.next,
                        erosion: field.erosion,
                        calculated: field.calculated
                    });
                });
                this.building.cadastreBuildingCategory = this.calculatedAll.category.code;
                this.building.cadastreBuildingCategoryVol = this.calculatedAll.category.volume;
                this.building.calculated = this.calculatedAll.calculated;

                if (!this.building.settings) {
                    this.building.settings = {};
                }
                this.building.settings.indexes = this.coefficient.index;
                this.building.newIncome = this.comparison;

                this.$http.post('new-real-estate/building', this.building)
                    .then(res => {
                        if (res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.building.success'),
                                type: 'success'
                            });
                            this.$router.go(0);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: res.data.message,
                                type: 'error'
                            });
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.building.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
            multiSelectOptions(options) {
                const items = [];
                if (options && options.length > 0) {
                    options.forEach((option) => {
                        items.push({
                            id: option.id,
                            label: option.name
                        });
                    });
                }
                return items;
            },
            calculateVolume() {
                if (this.building.area && this.building.area > 0 && this.building.height && this.building.height > 0 && !this.building.hasManualVolume) {
                    this.building.volume = this.building.area * this.building.height;
                }
            },
            onBuildingAreaChange() {
                if (this.building.area && this.building.area > 0 && !this.comparison.rentArea) {
                    this.comparison = {
                        rentArea: this.building.area
                    }
                }
            },
            showCalculatedTable(id) {
                this.building.cadastreBuildingCategory = this.calculatedAll.category.code;
                this.building.cadastreBuildingCategoryVol = this.calculatedAll.category.volume;
                this.building.calculated = this.calculatedAll.calculated;

                const fields = this.checkedCustomFields;
                fields.forEach((field) => {
                    if (field.type && field.type === 'MULTISELECT') {
                        if (field.value && field.value.length > 0) {
                            let valueAsLabel = '';
                            field.value.forEach((option_id) => {
                                const optionSelected = this.getReferenceById(field.reference.code, option_id);
                                if (optionSelected && optionSelected.name && optionSelected.name.length > 0) {
                                    if (valueAsLabel.length > 0) {
                                        valueAsLabel += ', ';
                                    }
                                    valueAsLabel += optionSelected.name;
                                }
                            });
                            field.valueAsLabel = valueAsLabel;
                        }
                    }
                });

                const data = {
                    realEstate: this.realEstate,
                    building: this.building,
                    coefficient: this.coefficient,
                    fields: fields,
                    depreciationFields: this.checkedDepreciationFields
                };
                this.$eventBus.$emit('showRealEstateBuildingCalculatedTable_' + id, data);
            },
            hasField(code) {
                if (this.building && this.building.cadastreBuilding && this.building.cadastreBuilding.id && this.building.cadastreBuilding.id > 0) {
                    if (this.building.cadastreBuilding.data && this.building.cadastreBuilding.data.fields && this.building.cadastreBuilding.data.fields.length > 0) {
                        return this.building.cadastreBuilding.data.fields.includes(code);
                    } else {
                        return false;
                    }
                } else {
                    return this.formDefault.fields.includes(code);
                }
            },
            isLeftCustomField(field) {
                return !field.system && field.alignment === 1 && this.hasField(field.code);
            },
            isRightCustomField(field) {
                return !field.system && field.alignment === 2 && this.hasField(field.code);
            },
            onCadastreBuildingSearch(searchTxt, loading) {
                loading(true);
                this.cadastreBuildings = [];
                this.cadastreSectionFilter.page.size = 1000;
                this.cadastreSectionFilter.realEstateId = this.building.realEstateId;
                this.cadastreSectionFilter.search = searchTxt;
                this.cadastreSectionFilter.volume = this.building.volume;
                this.cadastreSectionFilter.floors = this.building.floors;
                this.$http.post('cadastre/building/search', this.cadastreSectionFilter)
                    .then(res => {
                        this.cadastreBuildings = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCadastreBuildingFocus() {
                this.cadastreBuildings = [];
                this.cadastreSectionFilter.page.size = 1000;
                this.cadastreSectionFilter.realEstateId = this.building.realEstateId;
                this.cadastreSectionFilter.search = '';
                this.cadastreSectionFilter.volume = this.building.volume;
                this.cadastreSectionFilter.floors = this.building.floors;
                this.$http.post('cadastre/building/search', this.cadastreSectionFilter)
                    .then(res => {
                        this.cadastreBuildings = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            getReferenceById(code, id) {
                if (this.cadastreBuildingFieldReferences.hasOwnProperty(code)) {
                    const fieldReferences = this.cadastreBuildingFieldReferences[code];
                    const references = fieldReferences.filter((ref) => {
                        return ref.id === id
                    });
                    return references.length > 0 ? references[0] : null;
                } else {
                    return null;
                }
            },
            onFieldValueChange(field) {
                if (!field.system) {
                    let fieldValue = {};
                    if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                        if (field.type === 'LISTBOX') {
                            field.selected = this.getReferenceById(field.reference.code, field.value);
                        }
                        if (field.selected) {
                            fieldValue = {
                                id: field.selected.id,
                                code: field.selected.code
                            }
                        }
                        if (field.type === 'COMBOBOX') {
                            field.value = fieldValue;
                        }
                    } else if (field.type === 'MULTISELECT') {
                        fieldValue = [];
                        if (field.selected && field.selected.length > 0) {
                            field.selected.forEach((ref_id) => {
                                const ref = this.getReferenceById(field.reference.code, ref_id);
                                if (ref) {
                                    fieldValue.push({
                                        id: ref.id,
                                        code: ref.code
                                    })
                                }
                            });
                        }
                        field.value = fieldValue;
                    } else if (field.type === 'DATE_PICKER') {
                        if (field.date) {
                            fieldValue = formatDate(field.date);
                        }
                    } else {
                        fieldValue = field.value;
                    }
                    this.building.data.values[field.code] = fieldValue;
                    this.modelLastChangeTime = new Date().getTime();
                }
            },
            getFieldByCode(field_code) {
                const fields = this.cadastreBuildingFields.filter((field) => {
                    return field.code === field_code;
                });
                return (fields && fields.length > 0) ? fields[0] : null;
            },
            criteriaAsText(category_settings) {
                let text = "";
                if (category_settings) {
                    if (category_settings.hasOwnProperty('criteria')) {
                        const criteria_list = category_settings.criteria;
                        if (criteria_list && criteria_list.length > 0) {
                            criteria_list.forEach((criteria) => {
                                if (criteria && criteria.field) {
                                    const field = this.getFieldByCode(criteria.field);
                                    if (field) {
                                        if (criteria.valueMin || criteria.valueMax) {
                                            text += (field.name + ': ' + ((criteria.valueMin ? criteria.valueMin : '0.00') + ' - ' + (criteria.valueMax ? criteria.valueMax : '120 000.00')) + '. ');
                                        } else if (criteria.valueId) {
                                            const reference = this.getReferenceById(field.code, criteria.valueId);
                                            if (reference) {
                                                text += (' ' + field.name + ': ' + reference.name + '. ');
                                            }
                                        } else if (criteria.value) {
                                            text += (' ' + field.name + ': ' + criteria.value + '. ');
                                        }
                                    }
                                }
                            });
                        }
                        if (category_settings.capitalGroup && category_settings.capitalGroup.length > 0) {
                            text += (' Капиталлик гуруҳи: ' + category_settings.capitalGroup + '. ');
                        }
                    }
                }
                return text;
            },
            onChangeTechnicalCondition() {
                this.dilapidationLookupData = [];
                if (this.building.technicalCondition === "GOOD") {
                    this.dilapidationLookupData = [{key: 5, name: "5 %"}, {key: 10, name: "10 %"}, {
                        key: 15,
                        name: "15 %"
                    }, {key: 20, name: "20 %"}];
                } else if (this.building.technicalCondition === "SATISFACTORY") {
                    this.dilapidationLookupData = [{key: 25, name: "25 %"}, {key: 30, name: "30 %"}, {
                        key: 35,
                        name: "35 %"
                    }, {key: 40, name: "40 %"}];
                } else if (this.building.technicalCondition === "DISSATISFIED") {
                    this.dilapidationLookupData = [{key: 45, name: "45 %"}, {key: 50, name: "50 %"}, {
                        key: 55,
                        name: "55 %"
                    }, {key: 60, name: "60 %"}];
                } else if (this.building.technicalCondition === "ACCIDENT_STATE") {
                    this.dilapidationLookupData = [{key: 65, name: "65 %"}, {key: 70, name: "70 %"}, {
                        key: 75,
                        name: "75 %"
                    }, {key: 80, name: "80 %"}];
                } else if (this.building.technicalCondition === "UNUSABLE") {
                    this.dilapidationLookupData = [{key: 85, name: "85 %"}, {key: 90, name: "90 %"}, {
                        key: 95,
                        name: "95 %"
                    }, {key: 100, name: "100 %"}];
                } else {
                    this.building.dilapidationValueByExpert = 0;
                }
            },
            onDilapidationChange() {
                let dilapidation = this.building.dilapidationValueByExpert;
                let technicalCondition = this.building.technicalCondition;

                let total = 0;
                let fields = this.checkedDepreciationFields.filter(f => f.weight > 0);
                let fieldsLength = fields.length;
                if (dilapidation > 0 && technicalCondition) {
                    for (let i = 0; i < fields.length; i++) {
                        let field = fields[i];
                        field.erosion = calculateFieldErosion.getFieldErosion(field, dilapidation, technicalCondition, total, fieldsLength, i);
                        total += field.erosion;
                    }
                }

                let depreciationPercent = 0;
                if (this.isDepreciationPercent && dilapidation > 0) {
                    depreciationPercent = dilapidation;
                }
                this.building.depreciationPercent = depreciationPercent;
            },
            calculateCadastreBuildingData(result) {
                if (result.items && result.items.length > 0) {
                    let item = result.items[this.index];
                    if (item) {
                        let cadastreData = {};
                        cadastreData = {
                            name: item.Naimenovanie,
                            floors: item.Etajnost,
                            earthquakePoint: result.earthquakePoint,
                            communication: result.communication,
                            area: item.PloshadZastroyka,
                            heightInner: item.Visota,
                            madeYear: item.GodPostroyki,
                            wall: item.wall

                        };
                        this.calculateBuildingCadastreItemData(cadastreData)
                    }
                } else if (this.index === 0) {
                    this.setBasicBuildingDataByCadasterData(result);
                }
            },
            setBasicBuildingDataByCadasterData(result) {
                let cadastreData = {};
                cadastreData = {
                    floors: this.realEstate.storey,
                    earthquakePoint: result.earthquakePoint,
                    communication: result.communication,
                    area: result.PloshadZastroyka,
                    madeYear: result.GodPostroyki,
                    wall: this.realEstate.wall

                };
                this.calculateBuildingCadastreItemData(cadastreData)
            },
            calculateBuildingCadastreItemData(data) {
                this.cadastreData = data;
                if (!this.building.name.length > 0) {
                    this.building.name = this.cadastreData.name;
                }
                if (this.cadastreData.floors && !this.building.floors) {
                    this.building.floors = this.cadastreData.floors;
                }
                if (this.cadastreData.heightInner && !this.building.heightInner) {
                    this.building.heightInner = this.cadastreData.heightInner
                }
                if (this.cadastreData.earthquakePoint && !this.building.earthquakePoint) {
                    this.building.earthquakePoint = this.cadastreData.earthquakePoint
                }
                if (this.cadastreData.area && !this.building.area) {
                    this.building.area = this.cadastreData.area
                }
                if (this.cadastreData.madeYear && !this.building.madeYear) {
                    this.building.madeYear = this.cadastreData.madeYear;
                }

                const field = this.getFieldByCode('electrical_devices');
                if (field && this.cadastreData.communication && this.cadastreData.communication.length > 0) {
                    const reference = this.cadastreBuildingFieldReferences[field.reference.code];
                    let fieldValue = [];
                    this.cadastreData.communication.forEach((communal) => {
                        if (communal.name) {
                            const ref = reference.filter((ref) => ref.cadastreCode === communal.code)[0]
                            if (ref) {
                                fieldValue.push({
                                    id: ref.id,
                                    code: ref.code
                                })
                            }
                        }
                    });

                    if (fieldValue && !(field.selected && field.selected.length > 0)) {
                        if (fieldValue.length > 0) {
                            field.selected = [];
                            fieldValue.forEach((ref) => {
                                field.selected.push(ref.id);
                            });
                            this.onFieldValueChange(field);
                        }
                    }
                }
            },
            /* onRentingCoefficientFocus() {
                 this.incomeKkCoefficients = [];
                 this.incomeKxCoefficients = [];
                 this.incomeKtCoefficients = [];

                 this.$http.post('/real-estate/employment/coefficient/field/search', this.filter)
                     .then(res => {
                         const data = res.data;
                         this.incomeKkCoefficients = data.CoefficientOfContruction;
                         this.incomeKxCoefficients = data.CoefficientOfConnectedArea;
                         this.incomeKtCoefficients = data.CoefficientOfCommercialGoal;
                     }, (err) => {
                         console.log(err)
                     })
             }, */
            showCadastreBuildingSelect(index) {
                this.$eventBus.$emit('showCadastreBuildingSelectModal_' + index)
            }
        },
        created() {
            this.init();
            this.$eventBus.$on('cadastreItem_' + this.index, (data) => {
                if (data) {
                    this.calculateBuildingCadastreItemData(data)
                }
            })
        }
    }
</script>

<style scoped>
    .live__scroll {
        vertical-align: middle;
        overflow-x: scroll;
        overflow-y: visible;
        height: 15rem;
    }

    .flex {
        display: flex;
        flex-wrap: nowrap;
    }

    .cadastre-building-input {
        border: 1px solid #cccccc;
        border-radius: 5px;
        min-height: 40px;
        align-items: center;
        padding: 5px;
        font-size: 15px;
        background-color: #fff;
    }

    .cadastre-building-input2 {
        border: 1px solid #cccccc;
        border-radius: 5px;
        min-height: 40px;
        align-items: center;
        padding: 5px;
        font-size: 15px;
        background-color: #fff;
        color: grey;
    }

    .valid {
        border: 1px solid #e53935;;
        border-radius: 5px;
        min-height: 40px;
        align-items: center;
        padding: 5px;
        font-size: 15px;
        background-color: #fff;
        color: grey;
    }

    .cadastre-building-wrapper {
        cursor: pointer;
    }

    .cadastre-building-wrapper p:hover {
        border: 1px solid #60B4FA;
        background-color: #D6EBFE;
    }
</style>